import { useQuery } from 'react-query';

import * as companyApi from 'resources/company/company.api';

const getSubscription = async () => {
  const subscription = await companyApi.getSubscription();

  return subscription;
};

export default function useSubscription(companyId) {
  return useQuery(
    ['company.subscription', companyId],
    () => getSubscription(),
  );
}
